import { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import useFetch from "../../../../hooks/useFetch";
import ForbiddenMessage from "../../../Mensajes/ForbiddenMessage";
import SuccessMessage from "../../../Mensajes/SuccessMessage";
import ServerMessage from "../../../Mensajes/ServerMessage";

/**
 * PruebaCrear Component
 * @description: Componente que permite agregar un nuevo prueba.
 * @date 6/12/2022.
 * @param Props Ninguno
 * @returns JSX de la tabla de pruebas.
 */

const PruebaCrear = () => {
  const [show, setShow] = useState(false);
  const { sendRequest, error, setError, serverMessage, setServerMessage } =
    useFetch();

  //Formulario
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      nombre: "",
      estatus: "1",
    },
  });

  //Función que hace el POST para crear el prueba.
  const createPrueba = (data: any) => {
    sendRequest(
      {
        url: `/prueba`,
        method: "POST",
        body: data,
      },
      (variable: any) => {
        setShow(true);
        reset({
          nombre: "",
          estatus: "1",
        });
      }
    );
  };

  return (
    <Container>
      <h1>Agregar prueba</h1>
      {/** Alerta de guardado */}
      {show && (
        <SuccessMessage
          header="Prueba agregada"
          body="La prueba ha sido agregada de manera correcta."
          onCloseHandler={() => setShow(false)}
        />
      )}
      {/** Error del servidor */}
      {serverMessage && (
        <ServerMessage
          message={serverMessage}
          onCloseHandler={() => setServerMessage(undefined)}
        />
      )}
      {error === 403 && (
        <ForbiddenMessage onCloseHandler={() => setError(null)} />
      )}
      {/** Formulario */}
      <Form onSubmit={handleSubmit(createPrueba)}>
        <Row className="mb-3">
          <Form.Group as={Col} md="12" className="mb-3">
            <Form.Label>Nombre</Form.Label>
            <Controller
              name="nombre"
              control={control}
              rules={{
                required: true,
                maxLength: 50,
              }}
              render={({ field }) => {
                return (
                  <Form.Control
                    {...field}
                    onChange={(e) =>
                      field.onChange(e.target.value.toUpperCase())
                    }
                  />
                );
              }}
            />
            {errors.nombre && (
              <Form.Text style={{ color: "red" }}>
                El nombre es obligatorio y no puede ser mayor a 50 caracteres.
              </Form.Text>
            )}
          </Form.Group>
        </Row>

        <Button
          style={{
            backgroundColor: "#21618C",
            borderColor: "white",
          }}
          type="submit"
        >
          Guardar cambios
        </Button>
      </Form>
    </Container>
  );
};

export default PruebaCrear;
